/**
 * Região do imóvel a partir do CEP, pelas faixas dos Correios. Sem consulta externa:
 * a decisão do chat não depende de nenhum serviço fora do ar.
 *
 * Estado de São Paulo: 01000-000 a 19999-999.
 * - Capital: 01000-000 a 05999-999 e 08000-000 a 08499-999.
 * - Grande São Paulo: o resto de 06000-000 a 09999-999.
 * - Litoral (Baixada Santista, litoral norte e sul): 11000-000 a 11999-999.
 * - Interior: 12000-000 a 19999-999.
 */

export const REGIOES = ['capital', 'grande_sp', 'litoral_sp', 'interior_sp', 'fora_sp', 'desconhecida'] as const;
export type Regiao = (typeof REGIOES)[number];

export const REGIAO_LABEL: Record<Regiao, string> = {
  capital: 'São Paulo (capital)',
  grande_sp: 'Grande São Paulo',
  litoral_sp: 'Litoral de SP',
  interior_sp: 'Interior de SP',
  fora_sp: 'Fora do estado de SP',
  desconhecida: 'Não informada',
};

/**
 * CEP com 8 dígitos, a partir do texto da pessoa. Aceita "04612-060", "04612060" e também
 * 7 dígitos ("4612060"): o formulário antigo do site gravava o CEP como número e perdia o zero.
 */
export function parseCep(texto: string): string | null {
  const m = /\d{5}-?\d{3}|\d{7,8}/.exec(texto.replace(/\./g, ''));
  if (!m) return null;
  const d = m[0].replace(/\D/g, '');
  const cep = d.length === 7 ? `0${d}` : d;
  return /^\d{8}$/.test(cep) && cep !== '00000000' ? cep : null;
}

export function regiaoDoCep(cep: string): Regiao {
  if (!/^\d{8}$/.test(cep)) return 'desconhecida';
  const n = Number(cep.slice(0, 5));
  if ((n >= 1000 && n <= 5999) || (n >= 8000 && n <= 8499)) return 'capital';
  if (n >= 6000 && n <= 9999) return 'grande_sp';
  if (n >= 11000 && n <= 11999) return 'litoral_sp';
  if (n >= 12000 && n <= 19999) return 'interior_sp';
  return 'fora_sp';
}

export function formatCep(cep: string): string {
  return /^\d{8}$/.test(cep) ? `${cep.slice(0, 5)}-${cep.slice(5)}` : cep;
}
